import { ErrorPageComponent } from './shared/error-page/error-page.component';
import { QdeComponent } from './qde/qde.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CardUpgradeComponent } from './qde/card-upgrade/card-upgrade.component';
import { SuccessPageComponent } from './shared/success-page/success-page.component';
import { ApplicationTrackingComponent } from './track-application/application-tracking/application-tracking.component';
import { TrackappErrorComponent } from './track-application/trackapp-error/trackapp-error.component';
import { AddonCardComponent } from './addons/addon-card/addon-card.component';
import { CompleteApplicationComponent } from './complete-application/complete-application/complete-application.component';
import { SkipPopupComponent } from './complete-application/skip-popup/skip-popup.component';
import { ScheduleAppointmentComponent } from './schedule-appointment/schedule-appointment.component';
import { CatlogueReferComponent } from './catalogue/catlogue-refer/catlogue-refer.component';
import { CatalogueComponent } from './catalogue/catalogue/catalogue.component';
import { TrackAppHomeComponent } from './track-app-partner/track-app-home/track-app-home.component';
import {  TrackAppErrorComponent} from './track-app-partner/track-app-error/track-app-error.component';
import { CorporateCardComponent } from './track-application/corporate-card/corporate-card.component';
import { CardTrackingAndDeliveryComponent } from './qde/card-tracking-and-delivery/card-tracking-and-delivery.component';
//Added for local run
import { PersonalComponent } from './qde/personal/personal.component';
const routes: Routes = [
  {
    path: '',
    component: CatalogueComponent
    // loadChildren: './catalogue/catalogue.module#CatalogueModule'
  },
  {
    path: 'catalogue-partner',
    component: CatalogueComponent
    // loadChildren: './catalogue/catalogue.module#CatalogueModule'
  },
  {
    path: 'track-partner-error',
    component: TrackAppErrorComponent
  },
  {
    path: 'track-app-partner',
    component: TrackAppHomeComponent
    // loadChildren: './track-app-partner/track-app-partner.module#TrackAppPartnerModule'
  },
  {
    path: 'apply',
    component: QdeComponent
  },

  {
    path: 'catalogue-refer',
    component: CatlogueReferComponent
    // loadChildren: './catalogue/catalogue.module#CatalogueModule'
  },

  {
    path: 'apply/decisioning',
    component: CardUpgradeComponent
  },
  {
    path: 'apply/track-app-status',
    component: CardUpgradeComponent
  },
  {
    path: 'apply/track-app',
    component: CardTrackingAndDeliveryComponent
  },
  { 
    path: 'track-application', 
    component: ApplicationTrackingComponent 
  },
  { 
    path: 'track-application/track-error', 
    component: TrackappErrorComponent 
  },
  { 
    path: 'track-application/corporate-card', 
    component: CorporateCardComponent 
  },
  {
    path: 'complete-application',
    component: CompleteApplicationComponent
  },
  { 
    path: 'skip-popup', 
    component: SkipPopupComponent 
  },
  { 
    path: 'schedule-appointment', 
    component: ScheduleAppointmentComponent 
  },
  {
    path: 'addon-card',
    component: AddonCardComponent
  },
  {
    path: 'error',
    component: TrackappErrorComponent
  },
  {
    path: 'success',
    component: SuccessPageComponent
  }
  ,
  {
    path: '404',
    component: ErrorPageComponent
  }
  
  //Added for local run
  // {
  //   path: 'apply/personal',
  //   component: PersonalComponent
  // }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}

